(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initializeWrapLanding = (root) => {
    if (!root || root.dataset.wrapInitialized === 'true') return;

    root.dataset.wrapInitialized = 'true';
    root.classList.add('is-wrap-motion-ready');

    const video = root.querySelector('.wrap-hero__video');
    const videoControl = root.querySelector('[data-wrap-video-control]');
    const playIcon = videoControl?.querySelector('[data-wrap-video-play]');
    const pauseIcon = videoControl?.querySelector('[data-wrap-video-pause]');

    if (video && videoControl) {
      const updateVideoControl = () => {
        const isPaused = video.paused;

        if (playIcon) playIcon.hidden = !isPaused;
        if (pauseIcon) pauseIcon.hidden = isPaused;
        videoControl.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
      };

      const autoplayVideo = () => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;

        const playback = video.play();

        if (playback && typeof playback.then === 'function') {
          playback.then(updateVideoControl).catch(updateVideoControl);
        }
      };

      videoControl.addEventListener('click', () => {
        if (video.paused) {
          autoplayVideo();
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', updateVideoControl);
      video.addEventListener('pause', updateVideoControl);
      video.addEventListener('loadeddata', autoplayVideo, { once: true });
      video.addEventListener('canplay', autoplayVideo, { once: true });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && video.paused) autoplayVideo();
      });

      updateVideoControl();
      autoplayVideo();
    }

    root.querySelectorAll('[data-wrap-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-wrap-slider-track]');
      const previous = slider.querySelector('[data-wrap-slider-previous]');
      const next = slider.querySelector('[data-wrap-slider-next]');

      if (!track || !previous || !next) return;

      const move = (direction) => {
        track.scrollBy({
          left: direction * Math.max(track.clientWidth * 0.78, 280),
          behavior: 'smooth',
        });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
    });

    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );

      root.querySelectorAll('[data-wrap-reveal]').forEach((element) => observer.observe(element));
    } else {
      root.querySelectorAll('[data-wrap-reveal]').forEach((element) => element.classList.add('is-visible'));
    }
  };

  document.querySelectorAll('[data-wrap-landing]').forEach(initializeWrapLanding);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-wrap-landing]');
    initializeWrapLanding(root);
  });
})();
